import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import AsyncComponent from './components/asyncComponent'
import { Provider } from './components/context'

import './App.css'
import Home from './components/home/home'

const Medium = AsyncComponent(() =>
  import(/* webpackChunkName:"Medium" */ './components/Medium/Medium')
)
const Skills = AsyncComponent(() =>
  import(/* webpackChunkName:"Skills" */ './components/Skills/Skills')
)
const Projects = AsyncComponent(() =>
  import(/* webpackChunkName:"Projects" */ './components/Projects/Projects')
)
const Works = AsyncComponent(() =>
  import(/* webpackChunkName:"Works" */ './components/Works/Works')
)

class App extends Component {
  state = {
    testContext: 'yeah'
  }
  render() {
    return (
      <Router>
        <Switch>
          <Provider value={this.state}>
            <Route path="/" component={Home} exact />
            <Route path="/medium" component={Medium} />
            <Route path="/skills" component={Skills} />
            <Route path="/projects" component={Projects} />
            <Route path="/works" component={Works} />
          </Provider>
        </Switch>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js